import { PayloadAction } from '@reduxjs/toolkit';

import { PreviewState, VariantAdvancedFlatPreviews } from 'editor/src/store/editorModules/preview/types';

const setAdvancedFlatPreviewsReducer = (state: PreviewState, action: PayloadAction<VariantAdvancedFlatPreviews>) => {
  state.advancedFlatPreviews = action.payload;
};

export default setAdvancedFlatPreviewsReducer;
